var map = {
	"./Bin.svg": 255,
	"./Line 43.svg": 1408,
	"./Line 45.svg": 1409,
	"./Line 46.svg": 1410,
	"./addbutton.svg": 1411,
	"./contact.svg": 1412,
	"./hasnotification.svg": 407,
	"./help.svg": 422,
	"./img-pop-up-my-montepio-zippy-worten.svg": 1413,
	"./loading.svg": 54,
	"./logo_worten.svg": 1414,
	"./logo_zippy.svg": 1415,
	"./logout.svg": 367,
	"./montantepoupado.svg": 1416,
	"./nonotification.svg": 408,
	"./notificationnotread.svg": 1417,
	"./notificationread.svg": 1418,
	"./poupanca.svg": 412,
	"./poupancasvg.svg": 1419,
	"./protecao.svg": 248,
	"./protecao11.svg": 1420,
	"./protecaopoupanca.svg": 247,
	"./separator.svg": 614,
	"./umbrellaprotecao.svg": 1421,
	"./up.svg": 1422,
	"./user.svg": 409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 645;